import { merge } from 'lodash';

const xAxisData = [
  '0.5-1.0',
  '1.0-1.5',
  '1.5-2.0',
  '2.0-2.5',
  '2.5-3.0',
  '3.0-3.5',
  '3.5-4.0',
  '4.0-4.5',
  '4.5-5.0',
  '5.0-5.5',
  '5.5-6.0',
  '6.0-10.00',
  '>10.00'
];
const tooltip = {
  trigger: 'axis'
};
const splitLine = {
  show: true,
  lineStyle: {
    color: '#3b454f'
  }
};
const axisLine = {
  lineStyle: {
    color: '#3b454f',
    width: 2
  }
};
const color = ['#057FE1', '#B2D867', '#53FDEB', '#DA9049', '#FF7466', '#FF3C8F', '#3b48bc'];

export function expertBar1(op) {
  return merge(
    {
      color: '#058ae5',
      textStyle: { color: '#03e8f7' },
      title: { left: 'center', textStyle: { color: '#03e8f7' }, top: 15 },
      grid: { bottom: 80 },
      tooltip,
      yAxis: {
        splitLine,
        axisLine,
        minInterval: 1,
        max: v => {
          if (v.max < 0) {
            return v.max / 2;
          }
          if (v.max == 0) {
            return v.max + 0.0001;
          }
          return v.max < 100 ? 2 * v.max : v.max + 100;
          // return v.max * 2;
        }
      },
      xAxis: {
        type: 'category',
        name: '粒径通道/μm',
        nameLocation: 'center',
        nameGap: 60,
        splitLine,
        axisLine,
        axisLabel: { rotate: -90 },
        data: xAxisData
      },
      series: { type: 'bar', data: [] }
    },
    op
  );
}

export function expertLine1(op) {
  return merge(
    {
      color: ['#badd72', '#5fa7ff'],
      textStyle: { color: '#03e8f7' },
      title: { left: 'center', textStyle: { color: '#03e8f7' }, top: 15 },
      legend: {
        data: ['1-10', '0.5-1'],
        top: 10,
        orient: 'vertical',
        right: 10,
        textStyle: { color: '#03e8f7' }
      },
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'time',
        name: '时序/s',
        splitLine,
        axisLine,
        nameLocation: 'center',
        nameGap: 20
      },
      yAxis: {
        type: 'value',
        splitLine,
        axisLine,
        minInterval: 1,
        max: v => {
          // return v.max * 2;

          if (v.max < 0) {
            return v.max / 2;
          }
          if (v.max == 0) {
            return v.max + 0.0001;
          }
          return v.max < 100 ? 2 * v.max : v.max + 100;
        }
      },
      series: [
        { type: 'line', name: '1-10', showSymbol: false, data: [] },
        { type: 'line', name: '0.5-1', showSymbol: false, data: [] }
      ]
    },
    op
  );
}

export function expertLine2(op) {
  return merge(
    {
      color,
      textStyle: { color: '#03e8f7' },
      title: { left: 'center', text: '荧光总数和本底', textStyle: { color: '#03e8f7' }, top: 15 },
      legend: { bottom: 10, left: 'center', textStyle: { color: '#03e8f7' } },
      tooltip: { trigger: 'axis' },
      xAxis: { type: 'time', splitLine, axisLine, nameLocation: 'center', nameGap: 20 },
      yAxis: {
        type: 'value',
        splitLine,
        axisLine,
        minInterval: 1,
        max: v => {
          // return v.max * 2;

          if (v.max < 0) {
            return v.max / 2;
          }
          if (v.max == 0) {
            return v.max + 0.0001;
          }
          return v.max < 100 ? 2 * v.max : v.max + 100;
        }
      },
      series: [
        { type: 'line', showSymbol: false, data: [] },
        { type: 'line', showSymbol: false, data: [] },
        { type: 'line', showSymbol: false, data: [] }
      ]
    },
    op
  );
}
